import React from "react";
import "./style.scss";

type Props = {
  title: string;
  description: string;
  buttonText: string;
  buttonOnClick: () => void;
};

const EmptyOrdersBox = ({
  title,
  description,
  buttonText,
  buttonOnClick,
}: Props) => {
  return (
    <div className="empty-orders-box">
      <p>{title}</p>
      <span>{description}</span>
      <button onClick={buttonOnClick}>{buttonText}</button>
    </div>
  );
};

export default EmptyOrdersBox;
